(ns ycweb.app.pos.admin.printers.printers
  (:require
   #?@(:clj
       [[clojure.core.async :as a]]
       :cljs
       [[cljs-time.core :as dt]
        [cljs.core.async :as a]])
   [rum.core :as rum]
   [util.string :as str]
   [util.transform :as trf]
   [ycweb.components.flow :as flow]
   [ycweb.components.grid :as grid]
   [ycweb.util.core :as yuc]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.forms :as forms]
   [ycweb.components.wrapper :as w]
   [ycweb.components.transitions :as t]
   [ycweb.components.common :as cmn]
   [ycweb.components.toaster :as toaster]
   [ycweb.util.comms :as comms]
   [ycweb.util.directprint :as dp]))

(def printing-steps
  (forms/setup-steps
    [{:key :list :title "Store Printers"}
     {:key :printer-info :title "Printer Information"}
     {:key :printer-attributes :title "Printer attributes"}
     {:key :printer-jobs :title "Printer jobs"}
     {:key :printer-marker :title "Printer Toner Levels"}]))

(defn ipp-permission? [app-atom]
  (cmn/has-any-permission? app-atom
    ["SiteAdmin:Teams:Development" "SiteAdmin:Teams:IT" "SiteAdmin:Store:Manager"]))

(defn printers-modal [app-atom]
  (grid/menu-modal app-atom
    {:items
     [{:label "Scan network for printers"
       :action :store-admin/discover-printers
       :config {:show-loading? true}}

      {:label "Test printer by IP"
       :action :store-admin/test-printer-by-ip-screen
       :config {}}

      {:label "Cancel"
       :action :store-admin/modal-cancel
       :style
       {:full true :large true :text-link true :on-dark true}}]}))

(defmethod grid/action :store-admin/display-printer [app-atom {:keys [printer-barcode]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        printers-idx (cmn/curact app-atom :printers)
        {:keys [matched?] :as printer}
        (get printers-idx printer-barcode)]
    (cond
      (or
        matched?
        (ipp-permission? app-atom))
      (do
        (swap! process-atom assoc :selected-printer printer-barcode)
        (t/transition-next app-atom :store-admin/display-printer))

      :else
      (toaster/open-toast app-atom :error "This is an unknown printer. Please contact IT support." {}))))

(rum/defc printer-card < rum/reactive
  [app-atom {:keys [printer-barcode job-count ip-address state matched? reachable?] :as printer}]
  (let [{:keys [printer-make-and-model printer-location printer-icons printer-firmware-string-version printer-state-reasons] :as printer} (:printer-attributes printer)
        connected-colour
        (cond
          (nil? reachable?)
          :black

          reachable?
          :green

          (not reachable?)
          :red)]
    [:article.slat.packing-order-slat
     {:on-click #(grid/dispatch-action app-atom :store-admin/display-printer {:printer-barcode printer-barcode})}
     [:header.packing-order-slat__header
      [:div.packing-order-slat__title-wrapper
       [:h2.packing-order-slat__title
        [:span.packing-order-slat__order-no
         [:span.u-margin-right-10
          (cond
            (yuc/presence printer-icons)
            [:img
             {:src
              (if (yuc/presence printer-icons)
                (str "data:image/png;base64," printer-icons)
                "")
              :alt "Icon" :width "18" :height "18" :border "0"
              :style
              {:display "inline-block"
               :vertical-align "middle" :width "18px" :height "18px" :margin-right "4px" :border "none" :outline "none"}}]

            :else
            [:svg
             {:fill "#000000" :width "18px" :height "18px" :viewBox "-2 -2 24 24" :xmlns "http://www.w3.org/2000/svg" :preserveAspectRatio "xMinYMin"}
             [:path
              {:d "M16 14h1a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1V9h12v5zM4 4V0h12v4h1a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-1v4H4v-4H3a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1zm2 14h8v-7H6v7zM6 4h8V2H6v2z"}]])
          (str (if matched? printer-barcode "Unknown Device")
            (when printer-firmware-string-version
              (str " - " printer-firmware-string-version)) " ")]
         [:span
          {:class (yuc/bem :pill [:small :blue :packing-size])}
          state]
         [:span
          {:style {:float "right"}
           :class (yuc/bem :pill [:small connected-colour])}]]
        [:span.packing-order-slat__packlane
         printer-make-and-model]
        [:span.packing-order-slat__packlane
         ip-address]
        [:span.packing-order-slat__receiver-name
         [:b printer-location]]]]]
     [:ul.packing-order-slat__details
      [:li.packing-order-slat__item-count
       "State Message: " printer-state-reasons]
      [:li.packing-order-slat__status
       "Job Count: " job-count]]]))

(rum/defc list-printers < rum/reactive [app-atom]
  (let [printers-idx (cmn/curact app-atom :printers)]
    (w/wrapper app-atom "Store Admin" {:modal-fn printers-modal}
      [[:nav
        {:class (yuc/bem :section [:medium])}
        [:h2.u-text-center
         {:class (yuc/bem :heading [:standard])}
         "Store Printers"]]

       (cond
         (and
           (not (zero? (count printers-idx)))
           (ipp-permission? app-atom))
         (into
           [:div.slats]
           (map (fn [[_ p]] (printer-card app-atom p)) printers-idx))

         (and
           (zero? (count printers-idx))
           (ipp-permission? app-atom))
         [:div.section.u-text-center
          [:p.u-margin-bottom-8
           {:class (yuc/bem :paragraph [:large :flush])}
           "No printers have been discovered on the network yet."]
          (buttons/button
            "Scan network for Printers" #(grid/dispatch-action app-atom :store-admin/discover-printers {:show-loading? true})
            {:icon-right :refresh :raised true :text-default true :secondary true})]

         :else
         [:div "Coming soon!"])]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :store-admin/printers [app-atom]
  (list-printers app-atom))

;;===================-------------------=====================
;;                      SINGLE PRINTER
;;===================-------------------=====================

;;===================-------------------=====================
;;                      PRINTERS MODAL
;;===================-------------------=====================
(defn printer-modal [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        selected-printer (cmn/curact process-atom :selected-printer)
        printers-idx (cmn/curact app-atom :printers)
        printer (get printers-idx selected-printer)]
    (grid/menu-modal app-atom
      {:items
       [{:label "Ping Printer"
         :action :store-admin/ping-printer
         :config {:printer printer}}

        {:label "Print Test Page"
         :action :store-admin/print-test-page
         :config {:scan selected-printer}}

        {:label "Refresh Marker Details"
         :action :store-admin/refresh-printer-markers
         :config {:printer printer}}

        {:label "Refresh Job Summary"
         :action :store-admin/refresh-printer-jobs
         :config {:printer printer}}

        {:label "Cancel"
         :action :store-admin/modal-cancel
         :style
         {:full true :large true :text-link true :on-dark true}}]})))

(defmethod flow/barcode-dispatch-screen :store-admin/display-printer [_ app-atom scan]
  (grid/dispatch-action app-atom :store-admin/print-test-page {:scan scan}))

(defmethod grid/action :store-admin/ping-printer [app-atom {:keys [printer]} _]
  (let [reachable? (dp/ping-device (:ip-address printer))
        process-atom (cmn/process-cursor app-atom)
        selected-printer (cmn/curact process-atom :selected-printer)]
    (swap! app-atom update-in [:printers selected-printer]
      assoc :reachable? reachable?)))

(defmethod grid/action :store-admin/print-test-page [app-atom {:keys [scan]} _]
  (toaster/open-subtle-progress app-atom)
  (comms/send :pos/print-test-page {:printer-barcode scan}))

(defmethod comms/receive :store-admin/print-test-page [app-atom e]
  (toaster/open-toast app-atom :processing "Job sent to printer..." {:closetime 1500}))

(def job-states
  {0 :finished
   3 :pending
   4 :pending-held
   5 :processing
   6 :processing-held
   7 :cancelled
   8 :aborted
   9 :completed})

(defn check-printer-job-status [printer-uri job-id]
  (let [job-details
        (yuc/json-parse
          (dp/printer-job-details printer-uri job-id))
        job-state (get job-states (trf/tonumber (:job-state job-details)))
        job-status
        (cond
          (or
            (empty? job-details)
            (= job-state :cancelled)
            (= job-state :aborted)
            (= job-state :completed))
          :finished

          (or
            (= job-state :pending)
            (= job-state :pending-held)
            (= job-state :processing-held))
          :waiting

          (= job-state :processing)
          :processing)]

    {:job-details job-details
     :job-status job-status
     :job-state job-state
     :state-reasons (:job-state-reasons job-details)}))

(defmethod grid/action :store-admin/poll-printer-job
  [app-atom {:keys [connection/uri job/id documents] :as printer-config} _]
  (a/go-loop [poll-job-count 1 display-status :checking]
    (let [{:keys [job-details job-status job-state state-reasons]}
          (check-printer-job-status uri id)]

      (when (and (not= display-status job-state) (toaster/is-open? app-atom :pos/printing))
        (toaster/update-overlay-message app-atom :pos/printing
          {:sub-text (str "Job #" (:current-number documents) " - State: " (name job-state))}))

      (cond
        (or
          (= job-status :finished)
          (= poll-job-count 40))
        (let [printer-atom (rum/cursor-in app-atom [:printers (:device/name printer-config)])
              current-jobs (cmn/curact printer-atom :current-jobs)
              remaining-jobs (remove #(= id %) current-jobs)]

          (cond
            (empty? remaining-jobs)
            (let [next-screen (cmn/curact printer-atom :transition-to)]
              (when (toaster/is-open? app-atom :pos/printing)
                (toaster/close-overlay app-atom :pos/printing))
              (grid/dispatch-action app-atom :store-admin/check-toner-levels printer-config)
              (swap! app-atom update-in [:printers (:device/name printer-config)]
                (fn [printer]
                  (->
                    printer
                    (dissoc :transition-to)
                    (update :current-jobs #(disj % id)))))
              (when next-screen
                (t/transition-next app-atom next-screen)))

            :else
            (let [sorted-jobs (sort remaining-jobs)]
              (swap! printer-atom assoc :current-jobs (set sorted-jobs))
              (grid/dispatch-action app-atom :store-admin/poll-printer-job
                (->
                  printer-config
                  (assoc :job/id (first sorted-jobs))
                  (update-in [:documents :current-number] inc))))))

        :else
        (do
          (a/<! (a/timeout 500))
          (recur (inc poll-job-count) job-status))))))

(defmethod grid/action :store-admin/check-toner-levels
  [app-atom {:keys [connection/uri job/status] :as print-config} _]
  (let [process-atom (cmn/process-cursor app-atom)
        marker-channel (a/chan)]
    (a/go
      (a/>! marker-channel
        (dp/list-printer-markers uri)))
    (a/go-loop [retry-count 0]
      (let [val (a/<! marker-channel)]
        (cond
          (not (nil? val))
          (cond
            (:success val)
            (let [marker-details (yuc/json-parse (:marker-details val))]
              (swap! app-atom update-in [:printers (:device/name print-config)]
                (fn [printer]
                  (assoc printer :marker-info marker-details)))
              (comms/send :pos/printer-toner-levels
                {:printer-name (:device/name print-config)
                 :marker-details marker-details}))

            :else
            (dp/log {:marker-levels false :msg (:msg val)}))

          (> retry-count 40)
          (comms/send :pos/printer-toner-levels
            {:printer-name (:device/name print-config)
             :marker-details nil})

          :else
          (do
            (a/<! (a/timeout 500))
            (recur (inc retry-count))))))))

(defmethod comms/receive :pos/printer-toner-levels [app-atom e]
  (toaster/open-toast app-atom :processing (:msg e) {:closetime 5000}))

(defmethod grid/action :store-admin/display-printer-job [app-atom {:keys [printer-job show-loading?]} _]
  (when show-loading?
    (toaster/open-subtle-progress app-atom))
  (let [process-atom (cmn/process-cursor app-atom)
        selected-printer (cmn/curact process-atom :selected-printer)
        printers-idx (cmn/curact app-atom :printers)
        {:keys [printer-attributes]}
        (get printers-idx selected-printer)
        c (a/chan)]
    (a/go
      (a/>! c
        (dp/printer-job-details
          (first (:printer-uri-supported printer-attributes))
          (:job-id printer-job))))
    (a/go
      (loop []
        (let [val (a/<! c)]
          (if (not (nil? val))
            (let [job-details (yuc/json-parse val)]
              (when show-loading?
                (toaster/close-subtle-progress app-atom))
              (cond
                (and
                  job-details
                  (not (empty? job-details)))
                (swap! app-atom update-in [:printers selected-printer :job-summary]
                  (fn [job-summary]
                    (assoc job-summary (:job-id printer-job) job-details)))

                :else
                (swap! app-atom update-in [:printers selected-printer :job-summary] dissoc (:job-id printer-job))))
            (recur)))))))

;;===================-------------------=====================
;;                      PRINTERS MODAL
;;===================-------------------=====================

(rum/defc marker-slat < rum/reactive
  [app-atom {:keys [colour level level-perc colour-code level-low level-high marker-type] :as marker}]
  (let []
    [:article.slat.packing-order-slat
     [:header.packing-order-slat__header
      [:div.packing-order-slat__title-wrapper
       [:h2.packing-order-slat__title
        [:b (str (:name marker) " - " level-perc "% ")]
        [:span
         {:style {:background-color colour-code}
          :class (yuc/bem :pill [:small :packing-size])}
         [:span {:style {:color (if (= colour "Black") "white" "black")}} colour]]]
       [:ul
        {:class (yuc/bem :list [:flush])}
        [:li "Low: " level-low]
        [:li "Current: " level]
        [:li "High: " level-high]]
       [:p.u-margin-top-8 {:class (yuc/bem :paragraph [:flush])}
        (str "Marker Type: " marker-type)]]]]))

(rum/defc job-slat < rum/reactive
  [app-atom {:keys [job-id job-name job-originating-user-name job-state job-state-reasons] :as job}]
  [:article.slat.packing-order-slat.u-margin-bottom-24
   {:on-click
    #(grid/dispatch-action app-atom :store-admin/display-printer-job
       {:printer-job job})}
   [:header.packing-order-slat__header
    [:div.packing-order-slat__title-wrapper
     [:h2.packing-order-slat__title
      [:span.packing-order-slat__order-no
       [:span.u-margin-right-10 (str (when job-id (str job-id " - ")) job-name)]]
      [:span.packing-order-slat__packlane
       "Username: " job-originating-user-name]
      [:span.packing-order-slat__packlane
       (str "State: " job-state-reasons)]]]]])

(defmethod grid/action :store-admin/display-printer-job [app-atom {:keys [printer-job show-loading?]} _]
  (when show-loading?
    (toaster/open-subtle-progress app-atom))
  (let [process-atom (cmn/process-cursor app-atom)
        selected-printer (cmn/curact process-atom :selected-printer)
        printers-idx (cmn/curact app-atom :printers)
        {:keys [printer-attributes]}
        (get printers-idx selected-printer)
        c (a/chan)]
    (a/go
      (a/>! c
        (dp/printer-job-details
          (first (:printer-uri-supported printer-attributes))
          (:job-id printer-job))))
    (a/go
      (loop []
        (let [val (a/<! c)]
          (if (not (nil? val))
            (let [job-details (yuc/json-parse val)]
              (when show-loading?
                (toaster/close-subtle-progress app-atom))
              (cond
                (and
                  job-details
                  (not (empty? job-details)))
                (swap! app-atom update-in [:printers selected-printer :job-summary]
                  (fn [job-summary]
                    (assoc job-summary (:job-id printer-job) job-details)))

                :else
                (swap! app-atom update-in [:printers selected-printer :job-summary] dissoc (:job-id printer-job))))
            (recur)))))))

(rum/defcs display-printer < rum/reactive (rum/local {:display-jobs true :display-markers false} ::state) [s app-atom]
  (let [local-atom (::state s)
        display-jobs-atom (rum/cursor local-atom :display-jobs)
        display-jobs? (rum/react display-jobs-atom)
        display-markers-atom (rum/cursor local-atom :display-markers)
        display-markers? (rum/react display-markers-atom)
        process-atom (cmn/process-cursor app-atom)
        selected-printer (cmn/curact process-atom :selected-printer)
        printers-idx (cmn/curact app-atom :printers)
        {:keys [ip-address job-summary state  marker-info] :as printer}
        (get printers-idx selected-printer)
        {:keys [printer-make-and-model printer-location printer-icons printer-firmware-string-version printer-state-reasons printer-uri-supported] :as printer} (:printer-attributes printer)]
    (w/wrapper app-atom "Store Admin" {:modal-fn printer-modal}
      [[:nav
        {:class (yuc/bem :section [:medium])}
        [:h2.u-text-center {:class (yuc/bem :heading [:large])}
         [:b
          selected-printer]]
        [:ul.tabular-list
         [:li
          {:class (yuc/bem :tabular-list__item [:large])}
          [:b "Make & Model: "] printer-make-and-model]
         [:li
          {:class (yuc/bem :tabular-list__item [:large])}
          [:b "IP Address: "] ip-address]
         [:li
          {:class (yuc/bem :tabular-list__item [:large])}
          [:b "URI: "]
          (cond
            (coll? printer-uri-supported)
            (str/join "," printer-uri-supported)

            :else
            printer-uri-supported)]
         [:li
          {:class (yuc/bem :tabular-list__item [:large])}
          [:b "Location: "] printer-location]
         [:li
          {:class (yuc/bem :tabular-list__item [:large])}
          [:b "State: "] state]
         [:li
          {:class (yuc/bem :tabular-list__item [:large])}
          [:b "Firmware: "] printer-firmware-string-version]]

        [:p
         {:class (yuc/bem :paragraph [:large :flush])}
         [:b "Message:"]]
        [:p
         {:class (yuc/bem :paragraph [:large])}
         printer-state-reasons]]

       [:header.slat
        {:class (yuc/bem :admin-action-item__header [(when display-jobs? :is-maximised)])
         :on-click #(reset! display-jobs-atom (not display-jobs?))}
        [:h2 {:class (yuc/bem :heading [:medium-large :flush])}
         [:b "Jobs Summary"]
         [:i.js-load-dashboard-icon
          {:style {:float "right"}
           :class (yuc/bem :icon [:block (if display-jobs? :minus :plus) :is-dark])}]]]
       (when display-jobs?
         (into
           [:div]
           (map
             (fn [[k v]]
               (rum/with-key
                 (job-slat app-atom v) k))
             job-summary)))

       [:header.slat
        {:class (yuc/bem :admin-action-item__header [(when display-markers? :is-maximised)])
         :on-click #(reset! display-markers-atom (not display-markers?))}
        [:h2 {:class (yuc/bem :heading [:medium-large :flush])}
         [:b "Marker Details"]
         [:i.js-load-dashboard-icon
          {:style {:float "right"}
           :class (yuc/bem :icon [:block (if display-markers? :minus :plus) :is-dark])}]]]
       (when display-markers?
         (into
           [:div]
           (map
             #(rum/with-key (marker-slat app-atom %) (:colour %))
             marker-info)))]
      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :store-admin/display-printer [app-atom]
  (display-printer app-atom))

(defmethod grid/action :store-admin/refresh-printer-jobs [app-atom {:keys [printer]} _]
  (toaster/open-subtle-progress app-atom)
  (let [process-atom (cmn/process-cursor app-atom)
        selected-printer (cmn/curact process-atom :selected-printer)
        printer-jobs (yuc/json-parse (dp/list-printer-jobs (first (get-in printer [:printer-attributes :printer-uri-supported]))))]
    (swap! app-atom update-in [:printers selected-printer]
      (fn [printer]
        (assoc printer :job-summary (yuc/index-by :job-id printer-jobs))))
    (toaster/close-subtle-progress app-atom)))

(defmethod grid/action :store-admin/refresh-printer-markers [app-atom {:keys [printer]} _]
  (toaster/open-subtle-progress app-atom)
  (let [process-atom (cmn/process-cursor app-atom)
        selected-printer (cmn/curact process-atom :selected-printer)
        {:keys [success marker-details]} (dp/list-printer-markers (first (get-in printer [:printer-attributes :printer-uri-supported])))
        marker-info (when success (yuc/json-parse marker-details))]
    (cond
      success
      (swap! app-atom update-in [:printers selected-printer]
        (fn [printer]
          (assoc printer :marker-info marker-info)))

      :else
      (toaster/open-toast app-atom :error "Failed to fetch marker levels" {}))
    (toaster/close-subtle-progress app-atom)))

(defn parse-printers [printer-json]
  (cond
    (and
      (string? printer-json)
      (str/starts-with? printer-json "ERROR"))
    {:success false :msg printer-json}

    :else
    (let [parsed-printers
          (if (string? printer-json) (yuc/json-parse printer-json) printer-json)

          printers
          (map
            (fn [printer]
              (assoc printer
                :job-summary
                (yuc/index-by :job-id (:job-summary printer))))
            parsed-printers)]
      {:success true
       :printers printers})))

(defn- handle-discovered-printers
  "Process discovered printers and update app state"
  [app-atom {:keys [success msg printers timeout]} show-loading? next-screen]
  (when show-loading?
    (toaster/close-subtle-progress app-atom))
  (cond
    timeout
    (toaster/open-toast app-atom :error "Printer discovery timed out. Please try again." {:closetime 5000})

    success
    (do
      (swap! app-atom update :printers
        (fn [atom-printers]
          (let [printer-vals (vals atom-printers)
                printers-idx
                (->>
                  printer-vals
                  ;;Remove any unknown devices, they can be re-added if found.
                  (filter
                    (fn [printer]
                      (or
                        (not (yuc/presence (:matched? printer)))
                        (and
                          (yuc/presence (:matched? printer))
                          (:matched? printer)))))
                  (yuc/index-by :ip-address))
                updated-list
                (vals
                  (reduce
                    (fn [acc printer]
                      (cond
                        (yuc/presence (get acc (:ip-address printer)))
                        (update acc (:ip-address printer) merge
                          (assoc printer :matched? true))

                        :else
                        (assoc acc
                          (:ip-address printer)
                          (assoc printer :matched? false))))
                    printers-idx printers))]
            (yuc/index-by :printer-barcode updated-list))))
      (when next-screen
        (t/transition-next app-atom next-screen)))

    :else
    (toaster/open-toast app-atom :error (or msg "Failed to discover printers") {:closetime 5000})))

(defmethod grid/action :store-admin/discover-printers [app-atom {:keys [show-loading? next-screen]}]
  (when show-loading?
    (toaster/open-subtle-progress app-atom))
  ;; Use async method if available (doesn't block UI), otherwise fall back to sync
  (if (dp/list-printers-async-available?)
    (dp/list-printers-async app-atom ""
      (fn [result]
        (let [parsed (if (:printers result)
                       (update result :printers #(get (parse-printers %) :printers []))
                       (parse-printers (:printers result)))]
          (handle-discovered-printers app-atom parsed show-loading? next-screen))))
    ;; Fallback to sync method (will block UI on older app versions)
    (let [c (a/chan)]
      (a/go (a/>! c (dp/list-printers app-atom "")))
      (a/go
        (loop []
          (let [printer-data (a/<! c)]
            (if (not (nil? printer-data))
              (handle-discovered-printers app-atom (parse-printers printer-data) show-loading? next-screen)
              (recur))))))))

;;===================-------------------=====================
;;          UNIFIED THERMAL PRINTER TEST SCREENS
;;===================-------------------=====================

(rum/defc thermal-printer-template-selection < rum/reactive [app-atom]
  (w/wrapper app-atom "Test Thermal Printers" {}
    [[:nav
      {:class (yuc/bem :section [:medium])}
      [:h2.u-text-center
       {:class (yuc/bem :heading [:standard])}
       "Select Template to Test"]

      [:div.section
       ;; Receipt button
       [:div.u-margin-bottom-16
        (buttons/button
          "Receipt (pos-order)"
          #(do
             (swap! app-atom assoc-in [:thermal-test :template] "pos-order")
             (t/transition-next app-atom :store-admin/test-thermal-printer-select))
          {:icon-right :receipt :raised true :large true})]

       ;; Return Slip button
       [:div.u-margin-bottom-16
        (buttons/button
          "Return Slip (pos-return)"
          #(do
             (swap! app-atom assoc-in [:thermal-test :template] "pos-return")
             (t/transition-next app-atom :store-admin/test-thermal-printer-select))
          {:icon-right :assignment-return :raised true :large true})]

       ;; Collection Slip button
       [:div.u-margin-bottom-16
        (buttons/button
          "Collection Slip (pos-collection)"
          #(do
             (swap! app-atom assoc-in [:thermal-test :template] "pos-collection")
             (t/transition-next app-atom :store-admin/test-thermal-printer-select))
          {:icon-right :local-shipping :raised true :large true})]]]]

    []

    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-plain true})))

(defmethod flow/render-screen :store-admin/test-thermal-printers [app-atom]
  (thermal-printer-template-selection app-atom))

(rum/defc thermal-printer-select < rum/reactive [app-atom]
  (let [selected-template (cmn/curact app-atom [:thermal-test :template])
        template-display
        (case selected-template
          "pos-order" "Receipt"
          "pos-return" "Return Slip"
          "pos-collection" "Collection Slip"
          "Unknown")
        has-device? (yuc/has-device-printer?)]
    (w/wrapper app-atom "Select Printer" {}
      [[:nav
        {:class (yuc/bem :section [:medium])}
        [:h2.u-text-center
         {:class (yuc/bem :heading [:standard])}
         (str "Print " template-display)]

        [:div.section
         ;; Device printer option (if available)
         (when has-device?
           [:div.u-margin-bottom-16
            (buttons/button
              "Use Device Printer"
              #(grid/dispatch-action app-atom :thermal-test/print-device {})
              {:icon-right :print :raised true :large true :primary true})])

         ;; Thermal stand alone printer option (always available)
         [:div.u-margin-bottom-16
          (buttons/button
            "Scan Printer"
            #(grid/dispatch-action app-atom :thermal-test/transistion-to-standalone-scan {})
            {:icon-right :qr-code-scanner :raised true :large true
             :primary (not has-device?)})]]

        [:p.u-text-center.u-margin-top-16
         {:class (yuc/bem :paragraph [:small])}
         (str "Testing: " template-display)]]]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-plain true}))))

(defmethod flow/render-screen :store-admin/test-thermal-printer-select [app-atom]
  (thermal-printer-select app-atom))

(defmethod comms/receive :pos/print-test-receipt [app-atom e]
  (toaster/close-subtle-progress app-atom))

(defmethod grid/action :thermal-test/print-device [app-atom _ _]
  (let [template (cmn/curact app-atom [:thermal-test :template])]
    (cond
      (and template (yuc/has-device-printer?))
      (do
        (toaster/open-subtle-progress app-atom)
        (comms/send :pos/print-test-receipt
          {:printer-barcode "DEVICE-PRINTER"
           :width 32
           :template template}))

      (not template)
      (toaster/open-toast app-atom :error
        "No template selected" {:closetime 3000})

      :else
      (toaster/open-toast app-atom :error
        "Device printer not available" {:closetime 3000}))))

(defmethod grid/action :thermal-test/transistion-to-standalone-scan [app-atom _ _]
  (let [template (cmn/curact app-atom [:thermal-test :template])]
    (if template
      (do
        ;; Store template for later use
        (swap! app-atom assoc-in [:printers :test-template] template)
        ;; Show message to scan printer
        (t/transition-next app-atom :store-admin/test-standalone-thermal-printer-select))
      (toaster/open-toast app-atom :error
        "No template selected" {:closetime 3000}))))

(rum/defc scan-printer < rum/reactive [app-atom]
  (w/wrapper app-atom "Test - Scan Printer" {}
    [[:div.section
      [:h2.u-text-center
       {:class (yuc/bem :heading [:standard])}
       "Scan Printer"]
      grid/barcode-icon]]
    [[:p.paragraph.paragraph--flush.u-text-center.u-margin-top-24
      ""]]

    (grid/pos-call-to-action
      {:left-fn #(t/transition-prev app-atom)
       :right-text "Scan Printer"
       :right-plain true})))

(defmethod flow/render-screen :store-admin/test-standalone-thermal-printer-select [app-atom]
  (scan-printer app-atom))

(defmethod flow/barcode-dispatch-screen :store-admin/test-standalone-thermal-printer-select [_ app-atom scan]
  (grid/dispatch-action app-atom :thermal-test/thermal-standalone-printer {:scan scan}))

(defmethod grid/action :thermal-test/thermal-standalone-printer [app-atom {:keys [scan]} _]
  (let [template (cmn/curact app-atom [:thermal-test :template])]
    (if template
      (do
        (swap! app-atom assoc-in [:printers :test-template] template)
        (toaster/open-subtle-progress app-atom)
        (comms/send :pos/print-test-receipt
          {:printer-barcode scan
           :width 42
           :template template}))
      (toaster/open-toast app-atom :error
        "No template selected" {:closetime 3000}))))

(defmethod flow/barcode-dispatch-screen :store-admin/test-thermal-printer-select [_ app-atom scan]
  (let [template (cmn/curact app-atom [:printers :test-template])]
    (toaster/open-subtle-progress app-atom)
    (comms/send :pos/print-test-receipt
      {:printer-barcode scan
       :width 42
       :template (or template "pos-order")})))

;;===================-------------------=====================
;;              MANUAL IP PRINTER TEST
;;===================-------------------=====================

(rum/defc test-printer-by-ip < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        test-ip-atom (rum/cursor process-atom :test-ip-printer)
        ip-address (cmn/curact test-ip-atom :ip-address)
        resource-path (cmn/curact test-ip-atom :resource-path)
        connection-result (cmn/curact test-ip-atom :result)
        checking? (cmn/curact test-ip-atom :checking?)]
    (w/wrapper app-atom "Test Printer by IP" {}
      [[:nav
        {:class (yuc/bem :section [:medium])}
        [:h2.u-text-center
         {:class (yuc/bem :heading [:standard])}
         "Enter Printer IP Address"]]

       [:div.section.section--medium
        (forms/input "IP Address:" "e.g: 10.115.67.19"
          (rum/cursor test-ip-atom :ip-address)
          {:required? true})

        (forms/input "Resource Path:" "e.g: /ipp/print"
          (rum/cursor test-ip-atom :resource-path)
          {:placeholder "/ipp/print"})]

       (when checking?
         [:div.section.u-text-center
          [:p "Checking printer connection..."]])

       (when connection-result
         [:div.section
          (cond
            (:success connection-result)
            [:div
             [:div.u-margin-bottom-8
              {:class (yuc/bem :paragraph [:flush])}
              [:span.u-text-success [:b "Connection successful!"]]
              [:p "Printer: " (:printer-name connection-result)]
              [:p "State: " (:printer-state connection-result)]]
             [:div.u-margin-top-16
              (buttons/button
                "Print Test Page"
                #(grid/dispatch-action app-atom :store-admin/test-print-by-ip
                   {:ip-address ip-address
                    :resource-path (or (yuc/presence resource-path) "/ipp/print")})
                {:icon-right :print :raised true :primary true})]]

            :else
            [:div
             {:class (yuc/bem :paragraph [:flush])}
             [:span.u-text-danger [:b "Connection failed"]]
             [:p (or (:message connection-result) "Unable to reach printer")]])])]

      []

      (grid/pos-call-to-action
        {:left-fn #(t/transition-prev app-atom)
         :right-fn
         #(grid/dispatch-action app-atom :store-admin/check-printer-ip
            {:ip-address ip-address
             :resource-path (or (yuc/presence resource-path) "/ipp/print")})
         :right-text "Check Connection"
         :right-style :primary
         :right-icon :wifi}))))

(defmethod flow/render-screen :store-admin/test-printer-by-ip [app-atom]
  (test-printer-by-ip app-atom))

(defmethod grid/action :store-admin/test-printer-by-ip-screen [app-atom _ _]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc :test-ip-printer
      {:ip-address ""
       :resource-path "/ipp/print"
       :result nil
       :checking? false})
    (grid/close-modal app-atom)
    (t/transition-next app-atom :store-admin/test-printer-by-ip)))

(defmethod grid/action :store-admin/check-printer-ip [app-atom {:keys [ip-address resource-path]} _]
  (let [process-atom (cmn/process-cursor app-atom)
        test-ip-atom (rum/cursor process-atom :test-ip-printer)]
    (when (yuc/presence ip-address)
      (swap! test-ip-atom assoc :checking? true :result nil)
      #?(:cljs
         (let [uri (str "ipp://" ip-address resource-path)]
           ;; First check if device is reachable
           (if (dp/ping-device ip-address)
             ;; Query printer attributes
             (let [attrs-json (dp/list-printer-attributes uri "*")
                   attrs (when attrs-json (yuc/json-parse attrs-json))]
               (swap! test-ip-atom assoc
                 :checking? false
                 :result
                 (if attrs
                   {:success true
                    :printer-name (or (:printer-make-and-model attrs) (:printer-name attrs) "Unknown")
                    :printer-state (or (:printer-state attrs) "unknown")
                    :uri uri}
                   {:success false
                    :message "Could not query printer attributes"})))
             ;; Not reachable
             (swap! test-ip-atom assoc
               :checking? false
               :result {:success false :message "Device not reachable on network"})))))))

(defmethod grid/action :store-admin/test-print-by-ip [app-atom {:keys [ip-address resource-path]} _]
  (let [uri (str "ipp://" ip-address resource-path)
        printer-barcode (str "MANUAL-" ip-address)]
    (toaster/open-subtle-progress app-atom)
    ;; Send test print via server (which generates the PDF)
    (comms/send :pos/print-test-page
      {:printer-barcode printer-barcode
       :manual-uri uri})))